module.exports = __webpack_public_path__ + "img/jobUnsel.753810ae.svg";